const Menu = [
  {
    name: 'Thông báo',
    active: 'my-business-announcements',
    link: '/my-business/announcements',
    icon: 'vtd vtd-notification',
    subMenu: []
  },
  {
    name: 'Quản lý đơn hàng',
    active: 'my-business-orders',
    link: '/my-business/orders',
    icon: 'vtd vtd-menu',
    subMenu: []
  },
  {
    name: 'Yêu cầu sản phẩm',
    active: 'mybusiness-requests',
    link: '/my-business/requests',
    icon: 'vtd vtd-menu',
    subMenu: []
  },
  {
    name: 'Quản lý sản phẩm',
    active: 'manage-product',
    link: '/my-business/products',
    icon: 'vtd vtd-product',
    subMenu: []
  }
];

export {Menu};



// WEBPACK FOOTER //
// ./components/layouts/business/menu/menu.js